import type { SimulationJobStatus } from '../../services/api';
import type { CommittedSimulationFrame } from './simulationPlayback';

export type StreamingViewerMode = 'STARTING' | 'LIVE' | 'PLAYBACK' | 'COMPLETED' | 'FAILED' | 'CANCELLED';

export const isTerminalSimulationJob = (status: SimulationJobStatus): boolean =>
  status === 'COMPLETED' || status === 'FAILED' || status === 'CANCELLED';

export const viewerModeForJob = (
  status: SimulationJobStatus,
  current: StreamingViewerMode,
): StreamingViewerMode => {
  if (status === 'PENDING') return current === 'PLAYBACK' ? current : 'STARTING';
  if (status === 'RUNNING') return current === 'PLAYBACK' ? current : 'LIVE';
  return status;
};

export const streamingFrameIndex = (
  mode: StreamingViewerMode,
  requestedIndex: number,
  frameCount: number,
): number => {
  const latest = Math.max(0, frameCount - 1);
  return mode === 'PLAYBACK'
    ? Math.max(0, Math.min(latest, Math.trunc(requestedIndex)))
    : latest;
};

export const frameBelongsToJob = (
  frame: Partial<CommittedSimulationFrame> & {
    jobId?: string;
    projectId?: number;
    designId?: number;
    simulationId?: number;
  },
  expected: { jobId: string; projectId: number; designId: number; simulationId: number },
): boolean => (
  frame.jobId === expected.jobId
  && Number(frame.projectId) === expected.projectId
  && Number(frame.designId) === expected.designId
  && Number(frame.simulationId) === expected.simulationId
);
